{
  "nl": {
    "login": {
      "acceptTos": "algemene voorwaarden",
      "acceptTosPrefix": "Ik ga akkoord met de ",
      "acceptTosRequired": "U moet akkoord gaan met de algemene voorwaarden om een account aan te maken.",
      "auth-ziggu/invalid-invitation-code": "Controleer bij de persoon die het met u heeft gedeeld of er een nieuwe link beschikbaar is. Als u al een account heeft, meld je dan aan.",
      "auth-ziggu/user-created": "Uw gebruikersaccount is aangemaakt! 🎉 We melden je nu aan, even geduld..",
      "auth/invalid-action-code": "Om veiligheidsredenen verlopen wachtwoord reset links na een tijdje. Als u nog steeds uw wachtwoord wilt resetten, kunt u een nieuwe reset e-mail aanvragen.",
      "auth/invalid-credential": "Het wachtwoord is ongeldig voor het opgegeven e-mailadres, of er bestaat geen account voor dit e-mailadres.",
      "auth/invalid-email": "Het e-mailadres is niet geldig.",
      "auth/network-request-failed": "Er is een netwerkfout opgetreden. Controleer uw verbinding en probeer opnieuw.",
      "auth/too-many-requests": "Te veel verzoeken, probeer het later opnieuw.",
      "backToLogin": "Terug naar aanmelden",
      "cookiePolicy": "Cookiebeleid",
      "emailAddress": "E-mailadres",
      "emailAddressInvalid": "Voer een geldig e-mailadres in",
      "emailAddressRequired": "E-mailadres is verplicht",
      "googleLogin": "Aanmelden met Google",
      "notification_error_no_access": "Uw account heeft geen toegang.",
      "notification_error_session_expired": "Uw sessie is verlopen, meld je opnieuw aan.",
      "notification_success_logout": "U bent afgemeld van uw account.",
      "password": "Wachtwoord",
      "passwordConfirmMatchRequired": "Wachtwoord bevestiging komt niet overeen",
      "passwordConfirmRequired": "Wachtwoord bevestiging is verplicht",
      "passwordForgot": "Wachtwoord vergeten?",
      "passwordLengthRequired": "Wachtwoord moet minimaal 8 tekens bevatten",
      "passwordRequired": "Wachtwoord is verplicht",
      "password_confirm": "Wachtwoord bevestiging",
      "privacyPolicy": "Privacybeleid",
      "submit_expired_reset": "Nieuwe wachtwoord reset aanvragen",
      "submit_expired_signup": "Terug naar aanmelden",
      "submit_login": "Aanmelden",
      "submit_password_forgot": "Wachtwoord reset aanvragen",
      "submit_password_reset": "Wachtwoord resetten",
      "submit_signup": "Account aanmaken",
      "success_password_forgot": "Als u een actief account heeft, is er een wachtwoord reset e-mail verzonden naar {email}. Controleer uw e-mail inbox, de link om uw wachtwoord opnieuw in te stellen verloopt over 1 uur.",
      "success_password_reset": "Wachtwoord reset succesvol, u wordt nu aangemeld...",
      "termsandconditionsPolicy": "Algemene voorwaarden",
      "title_expired_reset": "Oeps, dit is een verlopen link..",
      "title_expired_signup": "Deze uitnodigingslink is niet meer actief",
      "title_login": "Welkom terug!",
      "title_password_forgot": "Wachtwoord vergeten?",
      "title_password_reset": "Reset uw wachtwoord",
      "title_signup": "Voltooi uw registratie"
    }
  }
}
